jQuery(function($){
	const parentSelector = '.sc-email-list-manager--detail-lists'

	//Auth Options
	$(parentSelector).on('click', '.update-google_workspace-authentication', function(e){
		e.preventDefault();

		const parentForm = $(this).closest('form');
		const formData = new FormData(parentForm[0]);
        for (const [name, value] of formData.entries()) {
            console.log(`${name}: ${value}`);
        }

        console.log(formData);

		const data = {
			action: 'sc_email_list_manager__google_workspace_update_auth_fields',
			form_data: Object.fromEntries(formData)
		};

		$.post('/wp-admin/admin-ajax.php', data, function(response){
			console.log(response);
		});

		console.log('clicked');
	});

	$(parentSelector).on('click', '.authentication-options-header', function(e){
		$(this).closest('.no-sc-field-editor-padding').toggleClass('expanded');
	});

	let debounceTimer;
	$(parentSelector).on('keydown', '.field.google-group-settings--ajax-update input[ajax_field_name="name"]', function(){
		const el = $(this);
		clearTimeout(debounceTimer);
		debounceTimer = setTimeout(() => {
			updateGoogleListSetting(el);
		}, 500);
	});

	$(parentSelector).on('keydown', '.field.google-group-settings--ajax-update input[ajax_field_name="description"]', function(){
		const el = $(this);
		clearTimeout(debounceTimer);
		debounceTimer = setTimeout(() => {
			updateGoogleListSetting(el);
		}, 500);
	});

	$(parentSelector).on('change', '.field.google-group-settings--ajax-update [ajax_field_name="whoCanPostMessage"]', function(){
		updateGoogleListSetting($(this));
	});

	$(parentSelector).on('change', '.field.google-group-members--ajax-update [ajax_field_name="member_type"]', function(){
		updateGoogleListMemberType($(this));
	});

	$(document).on('click', '.list-member-action-group .list-member-action', function(){
		const parentDiv = $(this).closest('.list-member-action-group');
		parentDiv.find('.list-member-action').removeClass('active');
		$(this).addClass('active');
	});

	$(document).on('click', '.edit-list-member', function(){
		const parentDiv = $(this).closest('.list-member-actions');
		parentDiv.toggleClass('edit-list-member-open');
	});

	$(document).on('click', '.edit-list-member-bg', function(){
		const parentDiv = $(this).closest('.list-member-actions');
		parentDiv.toggleClass('edit-list-member-open');
	});

	function updateGoogleListSetting(el) {
		setTimeout(function(){
			const listDiv = el.closest('.detail-list');
			const address = listDiv.attr('address');
			const parentDiv = el.closest('.field');
			const fieldName = el.attr('ajax_field_name');
			const value = el.val();
			let addressSafe = address.replace('@', '__at__');
			addressSafe = addressSafe.replace('.', '__dot__');

			console.log(addressSafe);

			const data = {
				action: 'sc_email_list_manager__google_workspace_update_list_settings',
				address: address,
				field_name: fieldName,
				value: value,
			};

			$(document).trigger('ajaxFieldUpdateStart', [el]);

			$.post('/wp-admin/admin-ajax.php', data, function(response){
				console.log(response);
				const responseJson = JSON.parse(response);
				console.log(responseJson);

				$(document).trigger('ajaxFieldUpdateEnd', [el]);

				//Update Tags
				const tagsData = {
					action: 'sc_email_list_manager__google_workspace_update_heading_tags',
					result: responseJson.result,
				};

				console.log(tagsData);

				$.post('/wp-admin/admin-ajax.php', tagsData, function(tagsResponse){
					$('#' + addressSafe + '--heading-tags').html(tagsResponse);
					console.log('#' + addressSafe + '--heading-tags');
					console.log($('#' + addressSafe + '--heading-tags').length);
					console.log(tagsResponse);
				});

				//Refresh if Name
				console.log(fieldName);
				console.log(responseJson.result_value);
				if(fieldName == 'name' && responseJson.result_value) {
					console.log('#' + addressSafe + '--heading-name');
					console.log($('#' + addressSafe + '--heading-name').length);
					$('#' + addressSafe + '--heading-name').html(responseJson.result_value);
				}

				//Refresh if List Type
				if(fieldName == 'whoCanPostMessage') {
					const nameField = listDiv.find('.field.google-group-settings--ajax-update input[ajax_field_name="name"]');
					if(nameField.length) {
						setTimeout(function(){
							const updateNameData = {
								action: 'sc_email_list_manager__google_workspace_update_list_settings',
								address: address,
								field_name: 'name',
								value: nameField.first().val(),
							};

							$.post('/wp-admin/admin-ajax.php', updateNameData, function(updateNameResponse){
								console.log(updateNameResponse);
								console.log(JSON.parse(updateNameResponse));
							});
						}, 2000);
					}
				}
			});
		}, 300);
	}

	function updateGoogleListMemberType(el) {
		const parentDiv = el.closest('.list-member');
		const listAddress = parentDiv.attr('address');
		const memberEmail = parentDiv.attr('email');
		const value = el.val();

		const data = {
			action: 'sc_email_list_manager__google_workspace_update_member_type',
			list_address: listAddress,
			member_email: memberEmail,
			field: 'role',
			value: value,
		};
		console.log(data);

		$(document).trigger('ajaxFieldUpdateStart', [el]);

		$.post('/wp-admin/admin-ajax.php', data, function(response){
			console.log(response);
			const responseJson = JSON.parse(response);
			console.log(responseJson);

			$(document).trigger('ajaxFieldUpdateEnd', [el]);

			const typeLabel = $('#' + getSafeAddress(memberEmail) + '__' + getSafeAddress(listAddress) + '--member-type-label');
			let typeLabelHtml = capitalizeFirstLetter(value);
			if(value == 'MANAGER') typeLabelHtml = 'Editor';
			typeLabel.html(typeLabelHtml);
			typeLabel.removeClass(['OWNER', 'MANAGER', 'MEMBER']).addClass(value);

			setTimeout(function(){
				const refreshMembersData = {
					action: 'sc_email_list_manager__google_workspace_load_list_members',
					address: listAddress,
				};

				$.post('/wp-admin/admin-ajax.php', refreshMembersData, function(response){
					console.log(response);
					const responseJson = JSON.parse(response);
					console.log(responseJson);
				});
			}, 2000);
		});
	}


	function capitalizeFirstLetter(str) {
		if (!str || typeof str !== 'string') return ''; // Handle empty or non-string inputs
		return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
	}

});
